module.exports = __webpack_public_path__ + "static/media/stoev-s.96c9bdac.mp3";